<form [formGroup]="form">
    <div [ngClass]="(isErrorOnDeliveryDate || isErrorOnDeliveryPeriod) ? 'is-error' : ''">
        <div class="field is-relative">

            <label class="label">
                <span *ngIf="(deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDate?.length ?? 0) > 0" class="ml-2">{{deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDate}}*</span>
                <span *ngIf="(deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDate?.length ?? 0) == 0" class="ml-2">Liefertag*</span>
            </label>
            <article *ngIf="showBlockedDays && getBlockedDaysFromYearAndMonth().length > 0" class="message is-warning is-absolute">
                <div *ngFor="let blockedDay of getBlockedDaysFromYearAndMonth()" class="message-body">
                    <p>
                        <b>
                            {{ blockedDay.from | date:'dd.MM.yyyy' }}
                            <span *ngIf="blockedDay.from !== blockedDay.to">
                            bis {{ blockedDay.to | date:'dd.MM.yyyy' }}
                            </span><br>
                        </b>
                        {{ blockedDay.txt }}
                    </p>
                </div>
            </article>
            <p-datepicker

                    formControlName="deliveryDate"
                    (onShow)="showBlockedDays = true"
                    (onClose)="showBlockedDays=false"
                    (onMonthChange)="setBlockedDaysFromMonthAndYear($event)"
                    (onYearChange)="setBlockedDaysFromMonthAndYear($event)"
                    [firstDayOfWeek]="1"
                    [disabledDates]="disabledDates"
                    [disabledDays]="disabledDays"
                    [minDate]="minDate"
                    [showIcon]="true"
                    [readonlyInput]="true"

                    ariaLabel="Lieferdatum auswählen"
                    dataType="date"
                    dateFormat="dd.mm.yy"></p-datepicker>
            <p *ngIf="isErrorOnDeliveryDate" class="help is-danger">Bitte hinterlegen Sie ein Lieferdatum.</p>
        </div>

        <div *ngIf="deliveryPeriods.length > 0" class="field">
            <label class="label">Lieferzeitraum*</label>
            <div class="select" [ngClass]="isErrorOnDeliveryPeriod ? 'is-danger' : ''">
                <select formControlName="deliveryPeriod" aria-label="Lieferzeitraum">
                    <option value="">Bitte wählen</option>
                    <option *ngFor="let dp of deliveryPeriods" [value]="dp">{{ dp }}</option>
                </select>
            </div>
            <p *ngIf="isErrorOnDeliveryPeriod" class="help is-danger">Bitte hinterlegen Sie einen Lieferzeitraum.</p>
        </div>
    </div>
    <p class="is-size-7 has-text-right">* Erforderliche Felder.</p>

</form>
